import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  baseURL = environment.apiURL
  constructor(private http: HttpClient) { }

  resetPassword(obj: any):Observable<any> {
    return this.http.put<any>(`${this.baseURL}api/v3/accounts/resetpassword/`, obj);
  }

  changePassword(old_password: any, new_password: any):Observable<any> {
    return this.http.put(`${this.baseURL}api/v3/accounts/changepassword/`, { old_password: old_password, new_password: new_password });
  }
}
